export const PULL_THRESHOLD_PX = 72;
export const MAX_PULL_PX = 112;
export const PULL_RESISTANCE = 0.5;
export const FAILED_NOTICE_MS = 4000;
export const AXIS_LOCK_PX = 10;
export const PULL_AREA_ATTRIBUTE = 'data-pull-to-refresh-area';
